import React from 'react';
import { OptionIconProps } from '../../Popup/PopupOption';

export const ContactUsIcon: React.FC<OptionIconProps> = ({
  disabled = false,
}): JSX.Element => {
  const color = disabled ? '#cccccc' : '#4D4558';

  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 0C7.67157 0 7 0.671573 7 1.5V3.5C7 4.15293 7.41717 4.70842 7.99951 4.91447V6C7.99951 6.19401 8.11174 6.3705 8.28743 6.45279C8.46313 6.53508 8.67056 6.50831 8.8196 6.38411L10.4805 5H12.5C13.3284 5 14 4.32843 14 3.5V1.5C14 0.671573 13.3284 0 12.5 0H8.5ZM8 1.5C8 1.22386 8.22386 1 8.5 1H12.5C12.7761 1 13 1.22386 13 1.5V3.5C13 3.77614 12.7761 4 12.5 4H10.2995C10.1825 4 10.0693 4.04101 9.97942 4.11589L8.99951 4.93248V4.5C8.99951 4.22395 8.7758 4.00013 8.49975 4C8.22373 3.99987 8 3.77606 8 3.5V1.5ZM2 5C2 3.89543 2.89543 3 4 3C5.10457 3 6 3.89543 6 5C6 6.10457 5.10457 7 4 7C2.89543 7 2 6.10457 2 5ZM4 4C3.44772 4 3 4.44772 3 5C3 5.55228 3.44772 6 4 6C4.55228 6 5 5.55228 5 5C5 4.44772 4.55228 4 4 4ZM1.49998 8L6.5 8C7.32843 8 8 8.67157 8 9.5C8 10.6161 7.54103 11.5103 6.78785 12.1148C6.04658 12.7098 5.05308 13 4 13C2.94692 13 1.95342 12.7098 1.21215 12.1148C0.458971 11.5103 0 10.6161 0 9.5C0 8.67161 0.671562 8 1.49998 8ZM6.5 9L1.49998 9C1.22387 9 1 9.22387 1 9.5C1 10.3169 1.32453 10.9227 1.8381 11.3349C2.36358 11.7567 3.12008 12 4 12C4.87992 12 5.63642 11.7567 6.1619 11.3349C6.67547 10.9227 7 10.3169 7 9.5C7 9.22386 6.77614 9 6.5 9Z"
        fill={color}
      />
    </svg>
  );
};
